import { createSlice } from "@reduxjs/toolkit"
import { SLICE_NAME, TYPE_UPDATE_LOADING_BUTTON } from "constants/common"

const initialState = {
    loadingButton: [],
    showBackdrop: false,
    isLoading: false,
    refreshGlobal: false,
    systemConfigs: null
}

export const commonSlice = createSlice({
    name: SLICE_NAME.COMMON,
    initialState,
    reducers: {
        updateLoadingButton: (state, action) => {
            let _loadingButton = [...state.loadingButton]
            if(action.payload?.type === TYPE_UPDATE_LOADING_BUTTON.ADD) {
                _loadingButton = [..._loadingButton, action.payload?.id]
            } else {
                _loadingButton = _loadingButton.filter(id => id !== action.payload?.id)
            }
            state.loadingButton = _loadingButton
        },
        setShowBackdrop: (state, action) => void(state.showBackdrop = action.payload),
        setIsLoading: (state, action) => void(state.isLoading = action.payload),
        toggleRefreshGlobal: (state, action) => void(state.refreshGlobal = !state.refreshGlobal),
        setSystemConfigs: (state, action) => void(state.systemConfigs = action.payload)
    }
})

export const { 
    updateLoadingButton, setShowBackdrop, setIsLoading, 
    toggleRefreshGlobal, setSystemConfigs } = commonSlice.actions
export default commonSlice.reducer
